export default __webpack_public_path__ + "static/media/iceglacier.7df0313a.png";